import Http from '@/libs/http/request'
import { appStore } from '@/stores'
import { saveAs } from 'file-saver'

export const managerLogin = data => {
  // 登录
  return Http.request({
    url: '/v1/user/login',
    data,
    method: 'post',
  })
}

export const checkManagerExists = params => {
  // 检测账号是否存在
  return Http.request({
    url: `/v1/user/checkUsernameExists`,
    showError: false,
    params,
    method: 'get',
  })
}

export const resetPassword = data => {
  // 重置密码
  return Http.request({
    url: '/v1/user/resetPassword',
    data,
    method: 'post',
  })
}
export const createCompany = data => {
  // 创建企业
  let url = '/v1/company/createCompany'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/createCompany'
  }
  return Http.request({
    url,
    data,
    method: 'post',
  })
}

export const setCompanyInfo = data => {
  let url = '/v1/company/updateCompany'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/updateCompany'
  }
  // 修改企业信息
  return Http.request({
    url,
    data,
    method: 'put',
  })
}

export const getInviteUrl = () => {
  // 生成邀请链接
  return Http.request({
    url: '/v1/company/generateInviteUrl',
    method: 'get',
  })
}

export const getInviteEmail = data => {
  // 发送邮件接口
  return Http.request({
    url: '/v1/company/sendInviteEmail',
    data,
    method: 'post',
  })
}

// export const createCompany = data => {
//   // 修改企业信息
//   return Http.request({
//     url: '/v1/user/setUserInfo',
//     data,
//     method: 'post',
//   })
// }

// export const getInviteUrl = () => {
//   // 获取邀请链接
//   return Http.request({
//     url: '/v1/company/generateInviteUrl',
//     method: 'post',
//   })
// }

export const updateCompany = data => {
  let url = '/v1/company/updateCompany'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + url
  }
  // 编辑企业
  return Http.request({
    url,
    data,
    method: 'put',
  })
}

// export const loginCompanyAccount = () => {
//   return Http.request({
//     url: '/v1/user/loginCompanyAccount/107230',
//     method: 'post',
//   })
// }
// const xToken = ''

// const loginCompany = async () => {
//   const res = await loginCompanyAccount()
//   console.log(res)
// }
// loginCompany()
export const getCompanyDetail = () => {
  let url = '/v1/company/getCompanyDetail'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/getCompanyDetail'
  }
  // 获取 企业详情
  return Http.request({
    url,
    method: 'get',
  })
}
export const getAllEmployees = () => {
  // 获取企业员工
  return Http.request({
    url: '/v1/company/getAllEmployeesByCompany',
    method: 'get',
  })
}

export const deleteCompany = code => {
  // 解散企业
  return Http.request({
    url: `/v1/company/deleteCompany/${code}`,
    method: 'delete',
  })
}

export const getEmployeeList = data => {
  let url = '/v1/company/getEmployeeList'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/getEmployeeList'
  }

  // 获取员工列表
  return Http.request({
    url,
    method: 'post',
    data,
  })
}
export const addEmployee = data => {
  // 添加员工
  return Http.request({
    url: '/v1/company/addEmployee',
    method: 'post',
    data,
  })
}

export const setEmployeeInfo = data => {
  let url = '/v1/company/setEmployeeInfo'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/setEmployeeInfo'
  }
  // 编辑员工信息
  return Http.request({
    url,
    method: 'put',
    data,
  })
}

export const sendInviteEmail = data => {
  // 发送邀请邮箱
  return Http.request({
    url: '/v1/company/sendInviteEmail',
    method: 'post',

    data,
  })
}

// /v1/company/removeEmployee
export const removeEmployee = data => {
  // 删除企业员工
  return Http.request({
    url: '/v1/company/removeEmployee',
    method: 'delete',
    data,
  })
}

// /v1/company/getEmployeeInfo
export const getEmployeeInfo = uid => {
  // 获取员工信息by uid
  return Http.request({
    url: `/v1/company/getEmployeeInfo/${uid}`,
    method: 'get',
  })
}

// /v1/company/multiDeleteCompanyEmployee

export const multiDeleteCompanyEmployee = data => {
  // 批量删除员工
  return Http.request({
    url: '/v1/company/multiDeleteCompanyEmployee',
    method: 'delete',
    data,
  })
}

// /v1/company/getEmployeeCount
export const getEmployeeCount = data => {
  // 获取企业员工总数
  return Http.request({
    url: '/v1/company/getEmployeeCount',
    method: 'get',
    data,
  })
}

// /v1/company/getPlanMembers
export const getPlanMembers = data => {
  let url = '/v1/company/getPlanMembers'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/getPlanMembers'
  }

  // 获取总授权
  return Http.request({
    url,
    method: 'get',
    data,
  })
}

export const getAuthMembers = data => {
  // 已授权员工
  return Http.request({
    url: '/v1/company/getAuthMembers',
    method: 'get',
    data,
  })
}

export const getEmployeeUpdfAuth = data => {
  return Http.request({
    url: '/v1/company/getEmployeeAuth',
    method: 'get',
    data,
  })
}

// 转移管理员
export const moveSuperAdmin = employeeId => {
  return Http.request({
    url: `/v1/company/moveSuperAdmin/${employeeId}`,
    method: 'post',
  })
}

// 查询所有管理员
export const getEmployeeAdminList = () => {
  let url = '/v1/company/getEmployeeAdminList'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/getEmployeeAdminList'
  }
  return Http.request({
    url,
    method: 'get',
  })
}

// 添加｜删除管理员
export const changeAdminRole = (employeeId, operate) => {
  return Http.request({
    url: `/v1/company/changeAdminRole/${employeeId}/op/${operate}`,
    method: 'post',
    showError: false,
  })
}

export const multiAuthMembers = data => {
  let url = '/v1/company/multiAuthMembers'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/multiAuthMembers'
  }
  // 批量授权员工
  return Http.request({
    url,
    method: 'post',
    showError: false,
    data,
  })
}

// /v1/company/authMembers
export const authMembers = data => {
  let url = '/v1/company/authMembers'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/authMembers'
  }
  // 授权
  return Http.request({
    url,
    method: 'post',
    showError: false,
    data,
  })
}

// /v1/company/getPlanExpirationTime 管理后台获取所有会员到期时间
export const getPlanExpirationTime = data => {
  let url = '/v1/company/getPlanExpirationTime'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/getPlanExpirationTime'
  }
  // 授权
  return Http.request({
    url,
    method: 'get',
    data,
  })
}

// /v1/company/multiCancelAuthMembers

export const multiCancelAuthMembers = data => {
  // 批量取消授权
  return Http.request({
    url: '/v1/company/multiCancelAuthMembers',
    method: 'get',
    data,
  })
}

// getOffsetCouponCount查询 兑换码数量

export const getOffsetCouponCount = data => {
  // 批量取消授权
  return Http.request({
    url: '/v1/active/getOffsetCouponCount',
    method: 'get',
    data,
  })
}
// 查询 指定兑换码数量

export const offsetCoupon = data => {
  // 批量取消授权
  return Http.request({
    url: `/v1/active/offsetCoupon/${data}`,
    method: 'get',
    data,
    showError: false,
  })
}
export const addCompanyEmployee = data => {
  let url = '/v1/company/addCompanyEmployee'
  if (appStore.useZgaApi) {
    // 国内使用新的域名
    url = appStore.zgaApiHost + '/v1/company/addCompanyEmployee'
  }

  // 批量取消授权
  return Http.request({
    url,
    method: 'put',
    data,
  })
}
export const sendEmployeeNotify = data => {
  // 批量取消授权
  return Http.request({
    url: `/v1/company/sendEmployeeNotify`,
    method: 'post',
    data,
  })
}

export const handleFileError = res => {
  if (typeof res.data !== 'undefined') {
    if (res.data.type === 'application/json') {
      const reader = new FileReader()
      reader.onload = function () {
        const message = JSON.parse(reader.result).msg
        ElMessage({
          showClose: true,
          message,
          type: 'error',
        })
      }
      reader.readAsText(new Blob([res.data]))
    }
  } else {
    var file = new Blob([res], { type: 'application/vnd.ms-excel' })

    if (appStore.isCN) {
      // 调用FileSaver.js提供的saveAs()方法来将Blob对象转为文件并保存到本地
      saveAs(file, '员工信息表.xlsx')
    } else {
      saveAs(file, 'Employees information form.xlsx')
    }
  }
}

export const exportMember = data => {
  return Http.request({
    url: '/v1/company/exportMember',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    responseType: 'blob',
    data,
  }).then(res => {
    handleFileError(res, '员工列表.xlsx')
  })
}

export const getEmployeeAiAuth = data => {
  // 批量取消授权
  return Http.request({
    url: `/v1/company/getEmployeeAiAuth`,
    method: 'get',
    data,
  })
}
// 获取AI的plan列表
export const getCompanyAiPlanList = data => {
  return Http.request({
    url: `/v1/company/getCompanyAiPlanList`,
    method: 'get',
    data,
  })
}

// 获取Sign的plan列表getEmployeeSignAuth
export const getEmployeeSignAuth = data => {
  return Http.request({
    url: `/v1/company/getEmployeeSignAuth`,
    method: 'get',
    data,
  })
}
// 获取Sign包的额度等详细信息
export const getSignAuthPackageQuota = data => {
  return Http.request({
    url: `/v1/company/getSignAuthPackageQuota`,
    method: 'get',
    data,
  })
}
// 获取sign授权包使用详情
export const getUsageAmountDetails = data => {
  return Http.request({
    url: `/v1/company/getUsageAmountDetails`,
    method: 'post',
    data,
  })
}
